<div class="div-footer">
    <div class="row">
        <div class="div-interno  col-md-6 col-12 co-sm-12 col-lg-6 col-xl-6">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3271.788234416248!2d-56.16268768518403!3d-34.911763481368205!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x959f81a12c3b1ddd%3A0x47b2dfa1016fa53b!2sInstituto%20IBEC!5e0!3m2!1ses-419!2suy!4v1597417364147!5m2!1ses-419!2suy"
            width="100%" height="320" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0">
            </iframe>
        </div>
        <div class="div-contacto col-md-6 col-12 co-sm-12 col-lg-6 col-xl-6">
            <div class="rejilla-contacto">
                <div class="div-redes">
                    <a class="a-social" href="https://www.instagram.com/ibec_internacional/" target="_blank"><img class="img-redes" src="../../../../../assets/images/footer/instagram-footer.png" /></a>
                    <a class="a-social" href="https://www.facebook.com/IbecInternacional" target="_blank"><img class="img-redes" src="../../../../../assets/images/footer/facebook-footer.png" /></a>
                    <a class="a-social" href="https://www.youtube.com/user/aycdigital" target="_blank"><img class="img-redes" src="../../../../../assets/images/footer/youtube-footer.png" /></a>
                    <a class="a-social" style="padding-right: 50px;" href="https://www.linkedin.com/school/institutoibec/" target="_blank"><img class="img-redes" src="../../../../../assets/images/footer/in-footer.png" /></a>
                </div>
                <div class="rejilla-contacto-down">
                    <div class="div-contact">
                        <strong>CONTACTO</strong><br>
                        <strong>Sede Central:</strong><br>
                         Bvar. España 2497 | MVD | UY <br>
                        (+598) 97 4232 32 | 2707 5466 <br>
                        IBECInternacional <br>
                        <a class="a-email" href="mailto:info@ibec.edu.uy">info@ibec.edu.uy</a> <br>
                        ibec.edu.uy<br>
                        <br>
                    </div>

                    <div>
                        <p>
                        <strong>DOCENTES</strong><br>
                        <a class="a-email" href="https://ibec.edu.uy/sgc" target="_blank">
                         Portal de Docentes
                        </a>
                        <br>
                        <a class="a-email" routerLink="/login">
                            Administración
                           </a>
                        </p>
                        <p>
                        <strong>ALUMNOS</strong><br>
                        <a class="a-email" href="https://ibec.edu.uy/portal">
                            Portal de Alumnos
                           </a>
                        </p>
                        <p>
                        <strong>LEGAL</strong><br>
                            <a class="a-email" routerLink="/privacidad">Política de Privacidad</a>
                        </p>
                    </div>
                  <div class="div-redes-responsive">
                      <br>
                    <a class="a-social" href="https://www.instagram.com/ibec_internacional/" target="_blank"><img class="img-redes" src="../../../../../assets/images/footer/instagram-footer.png" /></a>
                    <a class="a-social" href="https://www.facebook.com/IbecInternacional" target="_blank"><img class="img-redes" src="../../../../../assets/images/footer/facebook-footer.png" /></a>
                    <a class="a-social" href="https://www.youtube.com/user/aycdigital" target="_blank"><img class="img-redes" src="../../../../../assets/images/footer/youtube-footer.png" /></a>
                    <a class="a-social" style="padding-right: 50px;" href="https://www.linkedin.com/school/institutoibec/" target="_blank"><img class="img-redes" src="../../../../../assets/images/footer/in-footer.png" /></a>
                    <br>
                    <br>

                </div>

                </div>
            </div>
        </div>
    </div>
</div>

<div class="div-linea"></div>

<div class="div-footer2">
    <div class="rejilla-copyright">

        <div class="copyright-logo"><a routerLink=""><img src="../../../../../assets/images/footer/logo-footer.png" /></a></div>
        <div class="div-copyright">© Copyright 2020, IBEC [ A&C Digital ]</div>
        <div class="div-seguridad" style="padding-bottom: 10px;">
            Sitio Seguro y Certificado: ibec.edu.uy es un sitio seguro y certificado para realizar
            transacciones online IBECInternacional

        </div>
        <div><img src="../../../../../assets/images/footer/certif-seguridad-footer.png" /></div>
      <div style="margin-top: 10px;" class="row">
        <div class="copyright-logo-responsive"><a routerLink=""><img src="../../../../../assets/images/footer/logo-footer.png" /></a></div>
        <div style="margin-left: 10px;" class="div-copyright-responsive">© Copyright 2021, IBEC [ A&C Digital ]</div>
      </div>
    </div>
</div>

